/**
 * "Edit graphic" (0.92.0), on a graphics asset's page and on a graphics clip in the sequence editor: opens the asset
 * in PRISM Graphics. Saving there makes a new version of the asset; a clip on the timeline keeps the version it uses.
 * Shown when PRISM Graphics is configured and the person may upload; enabled for graphics made in PRISM Graphics.
 */
import type { CSSProperties } from 'react';
import { Pencil } from 'lucide-react';
import { useGraphic, useGraphicsSettings, useMe } from '../api/hooks';
import { graphicsEditor, type EditorRequest } from './GraphicsEditor';

export function EditGraphicButton({ assetId, title, defaults, className = 'btn sm', testId = 'edit-graphic', style }: {
  assetId: string; title?: string; defaults?: EditorRequest['defaults']; className?: string; testId?: string; style?: CSSProperties;
}) {
  const settings = useGraphicsSettings();
  const me = useMe().data;
  const canUpload = Boolean(me?.permissions.includes('asset.upload'));
  const configured = Boolean(settings.data?.editorOrigin);
  const g = useGraphic(assetId, configured && canUpload);
  if (!configured || !canUpload) return null;
  const editable = Boolean(g.data?.editable);
  return (
    <button type="button" className={className} style={style} disabled={!editable} data-testid={testId}
      title={g.isLoading ? 'Checking the graphic…' : editable ? 'Open this graphic in PRISM Graphics; saving makes a new version' : 'Only graphics made in PRISM Graphics can be edited there'}
      onClick={() => graphicsEditor.open({ mode: 'edit', assetId, title: title ?? g.data?.name, ...(defaults ? { defaults } : {}) })}>
      <Pencil size={13} /> Edit graphic
    </button>
  );
}
